<template>
  <div>
    <lm-image1 :shadow="false" :scale="false" :src="d1">
      <div slot="title">Intelligent, passionate and energetic life.</div>
    </lm-image1>
    <lm-swatches-block :space="43.75">
      <lm-container>
        <h2>Student Services</h2>
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in module1" :key="article.id">
            <lm-column
              style="margin-bottom: 35px;"
              :src="article.pic"
              :title="article.title"
              :description="article.intro"
              :links="article.articles"
            ></lm-column>
          </lm-col>
        </lm-row>
      </lm-container>
    </lm-swatches-block>
    <lm-swatches-block :space="43.75" backgroundColor="#f4f4f4">
      <h2>Student Organization & Activities</h2>
      <lm-container>
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in module2" :key="article.id">
            <lm-column
              style="margin-bottom: 35px;"
              :src="article.pic"
              :title="article.title"
              :description="article.intro"
              :links="article.articles"
            ></lm-column>
          </lm-col>
        </lm-row>
      </lm-container>
    </lm-swatches-block>
    <!-- <lm-swatches-block :space="43.75">
      <lm-container>
        <h2>Athletics & Volunteer services</h2>
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in module3" :key="article.id">
            <lm-column
              style="margin-bottom: 35px;"
              :src="article.pic"
              :title="article.title"
              :description="article.intro"
              :links="article.articles"
              ></lm-column>
          </lm-col>
        </lm-row>
      </lm-container>
    </lm-swatches-block> -->
    <poster-module :type="2"></poster-module>
  </div>
</template>

<script>
import { frontArticles4Memu, frontThrMenu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  mixins: [methodsMixins],
  data() {
    return {
      d1: require('@/assets/temp/d1.jpg'),
      module1: [],
      module2: [],
      module3: [],
      b14: require('@/assets/temp/b14.jpg')
    }
  },
  created() {
    const list1 = [],
    list2 = [],
    list3 = [],
    list4 = [],
    list5 = [],
    list6 = [],
    list7 = [];
    this.getArticles('y0lm76mqb0', 'y0lm97vz9o', list1);
    this.getArticles('y0lm76mqb0', 'y0lm97wfna', list2);
    this.getArticles('y0lm76mqb0', 'y0lm97xzjx', list3);
    this.getArticles('y0lm76mqb0', 'y0lm97ye9d', list4);
    this.getArticles('y0lm76mqb0', 'y0lw3il2s5', list5);
    this.getArticles('y0lm76mqb0', 'y0lwm0ez71', list6);
    this.getArticles('y0lm76mqb0', 'y0lwm0fkqj', list7);
    this.module1 = [{
      title: 'Insurance',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/j/y0lw3j6btj/article_pic/20240512204904360.png',
      intro: 'Read the insurance instruction from here.',
      articles: list1
    }, {
      title: 'Dining',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/b/y0lw3iqtab/article_pic/20240512204630927.png',
      intro: 'Four dining halls provide with healthy, multiple meals.',
      articles: list2
    }, {
      title: 'House',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/y/y0lw3inn5y/article_pic/20240512203603119.png',
      intro: 'The comfortable environment accommodation for students.',
      articles: list3
    }];
    this.module2 = [{
      title: 'Student Organization',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/5/y0lw3j97z5/article_pic/20240512205047155.png',
      intro: "Student Organization is an important part of international students' life at SMU.",
      articles: list4
    }, {
      title: 'Student Activities',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/v/y0lw3j7k1v/article_pic/20240512205022671.png',
      intro: 'SMU attaches great importance to students’ campus life and activities.',
      articles: list5
    }];
    this.module3 = [{
      title: 'Athletics',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/1/y0lw3j9rv1/article_pic/20240512205526215.png',
      intro: 'SMU offers multiple sports activities and competition platforms for international students.',
      articles: list6
    }, {
      title: 'Volunteer services',
      pic: 'https://istudy.smu.edu.cn/wb_smu/JDiy_data/entity/t/y0lw3jfr2t/article_pic/20240512205559130.png',
      intro: 'SMU international students can always be seen in various volunteer services.',
      articles: list7
    }];
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
@import '../home/index.scss';
</style>